export default {
    pageTitle: 'OptIn | Freemium',
    title: 'Welcome to the trial access',
    notice: 'Please set your password. Then your free trial period of 72 hours will start.',
    password: {
        label: 'Password',
        error: {
            required: 'Please enter your password',
            max: 'Maximal length is 255 chars',
            complex: 'Unfortunately, the password does not meet the criterias (please see below)'
        }
    },
    passwordRepeat: {
        label: 'Confirm password',
        error: {
            required: 'Please confirm your password',
            same: 'Both password entries must match'
        }
    }
}
